import { Box, styled, Typography } from "@mui/material";

export const BannerScrollClip = styled(Box)({
  overflow: "hidden",
  flexShrink: 0,
});

export const BannerSection = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.primary.light,
  color: theme.palette.primary.contrastText,
  borderRadius: theme.shape.borderRadius,
  marginBottom: theme.spacing(1),
}));

export const BannerTitleBox = styled(Box, {
  shouldForwardProp: (prop) => prop !== "titleWidth" && prop !== "isCollapsed",
})<{ titleWidth: number; isCollapsed?: boolean }>(({ theme, titleWidth, isCollapsed }) => ({
  width: titleWidth,
  flexShrink: 0,
  display: "flex",
  flexDirection: "column",
  justifyContent: isCollapsed ? "center" : "flex-end",
  padding: isCollapsed ? theme.spacing(1, 2) : theme.spacing(2),
}));

export const BannerTitle = styled(Typography)({
  fontWeight: 700,
  fontSize: "1rem",
  lineHeight: 1.2,
});

export const BannerSubtitle = styled(Typography)(({ theme }) => ({
  opacity: 0.8,
  marginTop: theme.spacing(0.5),
  fontSize: "0.7rem",
  lineHeight: 1.2,
}));
